module.exports = __webpack_public_path__ + "static/media/trash.e0f7a030.svg";